export default __webpack_public_path__ + "static/media/Helm of Vernant Fury.25cfe9f6.jpg";